/**
 * Launchpad tile visuals — editor chrome only (not block rendering).
 */

export const LAUNCHPAD_CATEGORY_ACCENTS = {
  blocks: { hue: 265, label: 'Blocks' },
  writing: { hue: 210, label: 'Writing' },
  organization: { hue: 32, label: 'Structure' },
  visual: { hue: 330, label: 'Visual' },
  tracking: { hue: 145, label: 'Tracking' },
  advanced: { hue: 185, label: 'Advanced' },
}

/** @type {Record<string, { preview: string, hue: number }>} */
export const BLOCK_LAUNCHPAD_VISUALS = {
  block_richtext: { preview: 'richtext', hue: 210 },
  block_card: { preview: 'card', hue: 265 },
  block_supporting_notes: { preview: 'card', hue: 248 },
  block_tabs: { preview: 'tabs', hue: 32 },
  block_hero: { preview: 'hero', hue: 280 },
  block_callout: { preview: 'callout', hue: 45 },
  block_quote: { preview: 'quote', hue: 300 },
  block_code: { preview: 'code', hue: 165 },
  block_media: { preview: 'media', hue: 330 },
  block_insight: { preview: 'insight', hue: 275 },
  block_summary: { preview: 'summary', hue: 205 },
  block_question: { preview: 'question', hue: 220 },
  block_reference: { preview: 'reference', hue: 195 },
  block_timeline: { preview: 'timeline', hue: 175 },
  block_warning: { preview: 'warning', hue: 38 },
  block_rule: { preview: 'rule', hue: 140 },
  block_zone_grid: { preview: 'grid', hue: 255 },
  block_steps: { preview: 'steps', hue: 155 },
  block_daily_row: { preview: 'daily', hue: 200 },
  block_step_row: { preview: 'steps', hue: 160 },
  block_lesson_tracker: { preview: 'lesson', hue: 125 },
  block_interviewer_test: { preview: 'checklist', hue: 115 },
  block_badge: { preview: 'badge', hue: 290 },
}

export function getLaunchpadVisual(type) {
  return (
    BLOCK_LAUNCHPAD_VISUALS[type] ?? {
      preview: 'default',
      hue: LAUNCHPAD_CATEGORY_ACCENTS.blocks.hue,
    }
  )
}
